import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Enterprise } from '../../../entity.types';
import { LawFirm, Lawyer } from '../../../../enterprise/enterprise.types';
import { numberWithSpaces } from '../../../../utils/math';
import styles from './entity_list_subtitle.module.scss';
import { EntityListSubtitleBlock } from '../EntityListComponents';

type Props = {
  wording: string;
  entity: Enterprise | LawFirm | Lawyer;
  handleClickDecision: Function;
};

export const EntityListSubtitle: FC<Props> = ({
  wording,
  entity,
  handleClickDecision,
}) => (
  <EntityListSubtitleBlock>
    <FormattedMessage
      id="entity/entity-lists/EntityListSubtitle.tsx/1"
      values={{ wording }}
    />
    <button
      className={styles.button}
      onClick={() => handleClickDecision(entity)}
      type="button"
    >
      <FormattedMessage
        id="entity/entity-lists/EntityListSubtitle.tsx/2"
        values={{
          count: parseInt(entity.nbDecisions, 10),
          countFormatted: numberWithSpaces(parseInt(entity.nbDecisions, 10)),
        }}
      />
    </button>
  </EntityListSubtitleBlock>
);
